<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-row class="align-center justify-center">
            <v-card flat color="#FBDE44FF">
              <v-card-title class="subtitle-2">
                로그인이 필요합니다.
              </v-card-title>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

export default {
  props: {
    msg: String
  },
  data: () => ({
  }),
}
</script>

<style scoped>

</style>
